import p from 'x/config/platform-specific'

const XDateRangePicker = p.comp.getXDateRangePicker()

export default XDateRangePicker
